/**
 * Accélération des zones maîtrisées au re-run NG+ (routes campagne uniquement).
 */

const KILLS_PER_STAGE_MULT_BY_MASTERY = [1, 1, 0.85, 0.75, 0.65, 0.55] as const

/** <1 = moins de kills requis par palier d'étape. */
export function getZoneMasteryKillsPerStageMult(masteryLevel: number): number {
  const lvl = Math.max(0, Math.min(5, Math.floor(Number(masteryLevel) || 0)))
  return KILLS_PER_STAGE_MULT_BY_MASTERY[lvl] ?? 1
}
